export const IMAGE_ACCEPT = "image/png,image/jpeg,image/jpg,image/webp";
export const VIDEO_ACCEPT = "video/mp4,video/quicktime,video/webm";
export const PDF_ACCEPT = "application/pdf";
export const MEDIA_ACCEPT = `${IMAGE_ACCEPT},${VIDEO_ACCEPT}`;
export const IMAGE_OR_PDF_ACCEPT = `${IMAGE_ACCEPT},${PDF_ACCEPT}`;
export const MEDIA_OR_PDF_ACCEPT = `${MEDIA_ACCEPT},${PDF_ACCEPT}`;
